module.exports = __webpack_public_path__ + "static/media/ReceiveVoucherRu.e1600c82.pdf";